module.exports = __webpack_public_path__ + "img/set.b676651f.jpeg";